import * as React from 'react'
import { useMemo } from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import MenuItem from '@mui/material/MenuItem'
import { selectAllSalesFunnels } from '@user/store/salesFunnel/slice'
import { Field, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import { OptionalField } from './typings'
import { useTheme } from '@mui/material/styles'

type Props = {
  disabled: boolean
  label?: string
  name: string
  size?: string
  whiteBackground?: boolean
  width?: number
} & OptionalField

export function SalesFunnelSelect<T>(props: Props) {
  const {
    disabled,
    hideOptional,
    label = 'Sales Funnel',
    name,
    required,
    size = 'medium',
    whiteBackground = false,
    width,
  } = props

  const { setValues } = useFormikContext<T>()

  const unsortedSalesFunnels = useSelector(selectAllSalesFunnels)

  const salesFunnels = useMemo(
    () =>
      unsortedSalesFunnels.sort((a, b) => {
        if (a.isDefault) return -1
        else if (b.isDefault) return 1
        return a.name.localeCompare(b.name)
      }),
    [unsortedSalesFunnels],
  )

  const onChangeSalesFunnel = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      setValues((current) => ({
        ...current,
        salesFunnelId: value,
        opportunityStageId: '',
      }))
    },
    [setValues],
  )
  const theme = useTheme()

  return hideOptional && !required ? null : (
    <Field
      name={name}
      label={label}
      component={MuiTextFieldFormik}
      onChange={onChangeSalesFunnel}
      required={required}
      select
      fullWidth={!width}
      size={size}
      margin="normal"
      disabled={disabled}
      style={{
        backgroundColor: whiteBackground
          ? theme.palette.common.white
          : 'transparent',
        width: width ? `${width}px` : '100%',
      }}
    >
      {salesFunnels.map(({ id, name, isDefault }) => (
        <MenuItem key={id} value={id}>
          {isDefault && '(Default) '}
          {name}
        </MenuItem>
      ))}
    </Field>
  )
}
